<template lang="html">
  <div class="page-section image-cards">
    <div class="container">
      <h2 class="list-title" v-if="title" v-html="title"></h2>

      <div class="list-content">
        <div
          class="list-item"
          v-for="(item, index) in items"
          :key="`image-card-${index}`"
        >
          <router-link
            v-if="image(item)"
            :to="parse(item).link"
            class="item-inner item-image"
            :style="{backgroundImage: `url('${image(item)}')`}"
          >
          </router-link>

          <div class="item-inner">
            <div class="item-content">
              <h2 @click="highlightField('heading')">{{parse(item).heading}}</h2>
              <div class="item-text" v-html="parse(item).text" @click="highlightField('text')"></div>
              <a
                class="item-link btn is-dark"
                v-if="parse(item).link"
                @click="highlightField('link')"
              >
                {{ parse(item).link_text }}
                <Sprite name="arrow" />
              </a>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import parseComponent from '@/mixins/parseComponent'

import Sprite from '@/components/Sprite'

export default {
  name: 'ImageCards',

  mixins: [parseComponent],

  props: {
    title: String,
    demoMode: Boolean,

    currentListItem: {
      type: Object,
      description: 'This is the type of list'
    },

    items: {
      type: Array,
      description: 'The current list item'
    }
  },

  computed: {
    image() {
      return (item) => {
        return this.demoMode ? this.parse(item).image_url : item.image_versions[0].url
      }
    }
  },

  components: {
    Sprite
  }
}
</script>

<style lang="sass">
@import '../../stylesheets/base/variables'
@import '../../stylesheets/helpers/mixins'
@import '../../stylesheets/base/theme'

.image-cards
  h1, h2
    width: 100%
    text-align: center

  .list-title
    margin-bottom: $gap-small

    @include media($media-gt-medium)
      margin-bottom: $gap-large

    @include themify($themes)
      color: themed('text')

  .list-content
    @include media($media-gt-medium)
      display: flex
      flex-wrap: wrap

      @include themify($themes)
        color: themed('text')

  .item-content
    padding: $gap-medium
    z-index: 10
    text-align: center

    h1, h2
      display: none

    @include media($media-gt-medium)
      h1, h2
        display: block

  .item-inner
    display: flex
    flex-direction: column
    justify-content: space-between
    height: 100%
    margin: 0

  .list-item
    margin: $gap-large 0
    overflow: hidden
    border-radius: 10px
    position: relative
    background: #fff
    box-shadow: $content-shadow

    @include media($media-gt-medium)
      padding: 0
      display: flex
      flex-direction: column
      flex: 1
      flex-basis: calc(#{percentage(1/3)} - 10px)
      align-items: center
      margin: 5px

    .item-text
      padding-bottom: $gap-large

      @include media($media-gt-medium)
        padding-bottom: $gap-small

    .item-link
      font-weight: bold
      text-decoration: none
      padding: 10px 20px
      position: absolute
      bottom: $gap-medium
      left: 50%
      transform: translateX(-50%)

      &:hover
        .sprite
          left: 5px
          opacity: 1

      .sprite
        position: relative
        width: 10px
        height: 10px
        top: 1px
        left: 3px
        transition: all .2s ease-in-out
        opacity: 0.5
        fill: #fff

      @include media($media-gt-medium)
        left: auto
        transform: none
        right: $gap-small

    .item-image
      background-size: cover
      background-position: 50% 50%
      background-repeat: no-repeat
      display: flex
      align-items: center
      height: 75px
      text-decoration: none
      overflow: hidden
      position: relative
      width: 100%

      @include media($media-gt-medium)
        height: 150px
</style>
